import React, { FC, useContext } from 'react';
import { Switch } from 'react-router-dom';
import { AuthRoute } from '..';
import {
	StoreProvider,
	usersStore,
	createUserStore,
	activityLogStore,
	rolesPermissionsStore,
	moneyDropStore,
	freeSpinsStore,
	gamblingReportStore,
	gamesReportStore,
	partnersReportStore,
	playerListStore,
	playerSessionsStore,
	playerTransactionsStore,
	AuthContext,
} from '../..';
import {
	CreateUser,
	Users,
	ActivityLog,
	RolesAndPermissions,
	Dashboard,
	MoneyDrop,
	FreeSpins,
	GamblingReport,
	GamesReport,
	PartnersReport,
	PlayerList,
	PlayerSessions,
	PlayerTransactions,
	Games,
} from '../../../view';
import * as urls from '../../../common/constants/urls';
import { PlayerDetails } from '../../../view/pages/PlayerDetails/PlayerDetails';
import { playerDetailsStore } from '../../state/playerDetails';
import { dashboardStore } from '../../state/dashboard';
import { InitLoader } from '../../../view/components/InitLoader/InitLoader';
import { GameCategories } from '../../../view/pages/GameCategories/GameCategories';
import { GamePartners } from '../../../view/pages/GamePartners/GamePartners';
import { GameProviders } from '../../../view/pages/GameProviders/GameProviders';
import { gamesStore } from '../../state/casinoGames';
import { gameCategoriesStore } from '../../state/casinoGameCategories';
import { gamePartnersStore } from '../../state/casinoGamePartners';
import { gameProvidersStore } from '../../state/casinoGameProviders';

const MainNavRoutes: FC = (): JSX.Element => {
	const { user, token } = useContext(AuthContext);
	if (!user && token) {
		return <InitLoader />;
	}

	return (
		<Switch>
			<AuthRoute exact path={urls.DASHBOARD_URL.value}>
				<StoreProvider store={dashboardStore} page='dashboard'>
					<Dashboard />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.PLAYER_LIST_URL.value}>
				<StoreProvider store={playerListStore} page='player-list'>
					<PlayerList />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.PLAYER_DETAILS_URL.value}>
				<StoreProvider store={playerDetailsStore} page='player-details'>
					<PlayerDetails />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.PLAYER_SESSIONS_URL.value}>
				<StoreProvider store={playerSessionsStore} page='player-sessions'>
					<PlayerSessions />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.PLAYER_TRANSACTIONS_URL.value}>
				<StoreProvider store={playerTransactionsStore} page='player-transactions'>
					<PlayerTransactions />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.REPORTS_GAMBLING_REPORT_URL.value}>
				<StoreProvider store={gamblingReportStore} page='gambling-report'>
					<GamblingReport />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.REPORTS_PARTNERS_REPORT_URL.value}>
				<StoreProvider store={partnersReportStore} page='partners-report'>
					<PartnersReport />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.REPORTS_GAMES_REPORT_URL.value}>
				<StoreProvider store={gamesReportStore} page='games-report'>
					<GamesReport />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.PROMOTIONAL_MONEY_DROP_URL.value}>
				<StoreProvider store={moneyDropStore} page='money-drop'>
					<MoneyDrop />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.PROMOTIONAL_FREE_SPINS_URL.value}>
				<StoreProvider store={freeSpinsStore} page='free-spins'>
					<FreeSpins />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.GAMES_URL.value}>
				<StoreProvider store={gamesStore} page='casino-games'>
					<Games />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.GAME_CATEGORIES_URL.value}>
				<StoreProvider store={gameCategoriesStore} page='game-categories'>
					<GameCategories />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.GAME_PROVIDERS_URL.value}>
				<StoreProvider store={gameProvidersStore} page='game-providers'>
					<GameProviders />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.GAME_PARTNERS_URL.value}>
				<StoreProvider store={gamePartnersStore} page='game-partners'>
					<GamePartners />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.BACKOFFICE_USERS_URL.value}>
				<StoreProvider store={usersStore} page='users'>
					<Users />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.CREATE_USER_URL.value}>
				<StoreProvider store={createUserStore} page='create-user'>
					<CreateUser />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.ROLES_PERMISSIONS_URL.value}>
				<StoreProvider store={rolesPermissionsStore} page='roles-permissions'>
					<RolesAndPermissions />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute exact path={urls.ACTIVITY_LOG_URL.value}>
				<StoreProvider store={activityLogStore} page='activity-log'>
					<ActivityLog />
				</StoreProvider>
			</AuthRoute>
			<AuthRoute path={`${urls.ACTIVITY_LOG_URL.value}/:id`}>
				<StoreProvider store={activityLogStore} page='user-activity-log'>
					<ActivityLog />
				</StoreProvider>
			</AuthRoute>
		</Switch>
	);
};

export { MainNavRoutes };
